import { render, staticRenderFns } from "./DragAccordion.vue?vue&type=template&id=726934c6&scoped=true&"
import script from "./DragAccordion.vue?vue&type=script&lang=ts&"
export * from "./DragAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./DragAccordion.vue?vue&type=style&index=0&id=726934c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726934c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpandTransition,VIcon})
